import {ClubUiData} from '@shared/models/club';
import React from 'react';
import SelectClubScreen from './SelectClubScreen';
import {useTranslation} from 'react-i18next';
import {useUser} from '@ui/provider/user/UserProvider';

interface Props {
    isEdit?: boolean;
    onFinish: () => void;
    onSkip?: () => void;
}

const AuthSelectClubScreen = (props: Props) => {
    const {setClub, user} = useUser();
    const [selectedClub, setSelectedClub] = React.useState<ClubUiData | undefined>(user?.sports?.golf?.club);
    const [lastSelectedClub, setLastSelectedClub] = React.useState<ClubUiData>();
    const [isLoading, setIsLoading] = React.useState(false);
    const {isEdit, onFinish, onSkip} = props;
    const {t} = useTranslation();

    const onSelectClub = async(club?: ClubUiData) => {
        setIsLoading(true);
        setLastSelectedClub(club);

        setSelectedClub(club);
        const response = await setClub(club);
        if (!response) {
            setSelectedClub(user?.sports?.golf?.club);
            setIsLoading(false);
            setLastSelectedClub(undefined);
            return;
        }

        onFinish();
    };

    const onNoClub = () => {
        if (!onSkip) {
            return;
        }

        if (!user?.sports?.golf?.club) {
            return onSkip();
        }

        setSelectedClub(undefined);
        onSelectClub();
    };

    return (
        <SelectClubScreen
            isEdit={isEdit}
            onSelect={onSelectClub}
            selectedClubs={selectedClub ? [selectedClub] : []}
            isLoading={isLoading}
            lastSelectedClub={lastSelectedClub}
            onSkip={onNoClub}
            title={t('auth.selectClub.title')}
        />
    );
};

export default AuthSelectClubScreen;
